import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  genralTab: boolean = true;
  isgenCollapsed = true;
  isCollapsed2 = true;
  isCollapsed3 = true;
  isCollapsed4 = true;
  isCollapsed5 = true;
  isCollapsed6 = true;
  isCollapsed7 = true;
  isCollapsed8 = true;
  isCollapsed9 = true;
  isCollapsed10 = true;
  isCollapsed11 = true;
  billTab: boolean;
  memberTab: boolean;
  secureTab: boolean;
  faqTab: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  onMenuTab(number) {
    this.genralTab = false;
    this.billTab = false;
    this.memberTab = false;
    this.secureTab = false;
    this.faqTab = false;
    if (number == '1') {
      this.genralTab = true;
    }
    else if (number == '2') {
      this.billTab = true;
    }
    else if (number == '3') {
      this.memberTab = true;
    }
    else if (number == '4') {
      this.secureTab = true;
    }
    else if (number == '5') {
      this.faqTab = true;
    }
  }

}
